// extracted by mini-css-extract-plugin
export default {"checkboxWrap":"cG8G21AWo92P3T5uvPU7","label":"DsA8b3Ny4jq3YOUw93iM","checkbox":"eycl3VHmoHmIxx9NcGIT","infoMsg":"FllGp_Yt73QG0kbf4saU","checkboxDisabled":"z4NrovPyFVwZhwJAP1i9"};